import { ObjectMeta, VersionCreationJob } from "@supernova-studio/model";
import { z } from "zod";
import { DTOCreateVersionInput } from "../../payloads";

export const DTODesignSystemVersion = z.object({
  id: z.string(),
  createdAt: z.coerce.date(),
  meta: ObjectMeta,
  version: z.string(),
  isReadonly: z.boolean(),
  changeLog: z.string(),
  designSystemId: z.string(),
});

export const DTODesignSystemVersionsListResponse = z.object({
  designSystemVersions: z.array(DTODesignSystemVersion),
});

export const DTODesignSystemVersionGetResponse = z.object({
  designSystemVersion: DTODesignSystemVersion,
});

export const DTODesignSystemVersionCreationResponse = z.object({
  meta: ObjectMeta,
  version: z.string(),
  changeLog: z.string(),
  isReadOnly: z.boolean(),
  designSystemId: z.string(),
  jobId: z.string(),
});

export const VersionSQSPayload = z.object({
  jobId: z.string(),
  designSystemId: z.string(),
  input: DTOCreateVersionInput,
});

export type VersionSQSPayload = z.infer<typeof VersionSQSPayload>;

export type DTODesignSystemVersionCreationResponse = z.infer<typeof DTODesignSystemVersionCreationResponse>;
export type DTODesignSystemVersion = z.infer<typeof DTODesignSystemVersion>;
export type DTODesignSystemVersionsListResponse = z.infer<typeof DTODesignSystemVersionsListResponse>;
export type DTODesignSystemVersionGetResponse = z.infer<typeof DTODesignSystemVersionGetResponse>;

export const DTODesignSystemVersionJobsResponse = z.object({
  jobs: z.array(VersionCreationJob),
});

export type DTODesignSystemVersionJobsResponse = z.infer<typeof DTODesignSystemVersionJobsResponse>;

// Creation job status response
export const DTODesignSystemVersionJobStatusResponse = z.object({
  job: VersionCreationJob,
});

export type DTODesignSystemVersionJobStatusResponse = z.infer<typeof DTODesignSystemVersionJobStatusResponse>;
